import Permissions from '@/security/permissions';
import PermissionChecker from '@/modules/iam/permission-checker';

export class CyclePermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.cycleRead,
    );
    this.import = permissionChecker.match(
      Permissions.values.cycleImport,
    );
    this.cycleAutocomplete = permissionChecker.match(
      Permissions.values.cycleAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.cycleCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.cycleEdit,
    );
    this.destroy = permissionChecker.match(
      Permissions.values.cycleDestroy,
    );
  }
}
